import React, {memo} from 'react'
import cx from 'classnames'

/* Actions */
import {actionCreators as productActionCreators} from '../../../../../redux/actions/productActions'

/* Components */
import VariantRow from '../row/VariantRow'
import VariantDropdown from '../dropdown/VariantDropdown'

/* Constants */
import {
  DESKTOP_VARIANT_TYPE_PROPS as VARIANT_TYPE_PROPS,
} from '../../../../../modules/variant/variantConstants'
import {PLATFORMS, ROUTE_PATHS} from '../../../../../core/route/routeConstants'

/* Utils */
import {generateUrlFromRoutePath} from '../../../../../core/route/routeUtils'
import {updateLocation} from '../../../../../modules/product/productDesktopUtils'
import {generateQueryString} from '../../../../../common/url/urlUtils'

/* Hooks */
import {useEffectOnlyOnUpdate} from '../../../../../common/react/hook/lifecycle'

/* Styles */
import s from './variant-panel.scss'

const VariantPanel = memo(({
  className,
  variants,
  activeVariant,
  unAvailableVariants,
  dispatch,
  queryParams,
  brandName,
  match,
  isAvailableProduct,
  sku,
  pageTypeForDavinci,
  isFashionProduct,
  categoryId,
  categoryName,
  listingId,
  merchantName,
  merchantId,
  price,
  productId,
}) => {

  const handleOnVariantChange = (variant) => {
    dispatch(productActionCreators.updateProductVariant.trigger(variant))
  }

  useEffectOnlyOnUpdate(() => {
    if (
      activeVariant?.hasCombination &&
      activeVariant?.sku !== match?.params?.productId
    ) {
      updateLocation({
        pathname: generateUrlFromRoutePath(
          ROUTE_PATHS[PLATFORMS.MOBILE].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU, {
            ...match?.params,
            productDetailUrlKeyword: activeVariant?.urlName,
            pdpPath: 'p',
            productId: activeVariant?.sku,
          },
        ),
        search: generateQueryString(queryParams),
      }, {
        isReplace: true,
      }, dispatch)
    }
  }, [activeVariant?.sku])

  if (!variants && !variants?.length > 0) {
    return null
  }

  return (
    <div className={cx(s.root, className)} data-test-id={'variant'}>
      {Object.keys(variants)?.map((variantName) => (
        VARIANT_TYPE_PROPS[variants[variantName].variantType]?.isDropdown ?
          <VariantDropdown
            dispatch={dispatch}
            isAvailableProduct={isAvailableProduct}
            variant={variants[variantName]}
            brandName={brandName}
            isFashionProduct={isFashionProduct}
            sku={sku}
            price={price}
            categoryId={categoryId}
            productId={productId}
            categoryName={categoryName}
            listingId={listingId}
            merchantName={merchantName}
            merchantId={merchantId}
            pageTypeForDavinci={pageTypeForDavinci}
            activeVariant={activeVariant}
            unAvailableVariants={unAvailableVariants}
            onVariantChange={handleOnVariantChange}/> :
          <VariantRow
            dispatch={dispatch}
            brandName={brandName}
            sku={sku}
            categoryId={categoryId}
            categoryName={categoryName}
            listingId={listingId}
            price={price}
            productId={productId}
            merchantName={merchantName}
            merchantId={merchantId}
            isFashionProduct={isFashionProduct}
            pageTypeForDavinci={pageTypeForDavinci}
            isAvailableProduct={isAvailableProduct}
            variant={variants[variantName]}
            activeVariant={activeVariant}
            unAvailableVariants={unAvailableVariants}
            onVariantChange={handleOnVariantChange}/>
      ))}
    </div>
  )
})

export default VariantPanel
